import React, { useState, useRef, useEffect } from 'react';

const ANSWERS = {
  'налоги': 'По вашему режиму УСН вам нужно платить авансовые платежи до 28 апреля, 28 июля, 28 октября. Декларация — до 31 марта следующего года. НДС не облагается.',
  'ндс': 'На режиме УСН НДС не облагается (ст. 346.11 НК РФ). На ОСНО ставка НДС — 22% с 2026 года.',
  'кассовый разрыв': 'Кассовый разрыв — это когда расходы превышают доходы в конкретный день. Khepri предсказывает разрывы на 14 дней вперёд. Если видите красную зону — проверьте возможность овердрафта или перенесите некритичные платежи.',
  'контрагент': 'Проверить контрагента можно на вкладке Counterparty. Введите ИНН — Khepri покажет риски: долги, арбитражные дела, массовые адреса.',
  'договор': 'Создать договор можно на вкладке Contracts. Khepri генерирует договор с учётом вашего налогового режима и сферы деятельности. Доступна подпись УКЭП.',
  'счёт': 'Открыть расчётный счёт можно через вкладку Banks. Там список из 10 банков с тарифами и бонусами для пользователей Khepri.',
  'торги': 'Для участия в госзакупках перейдите на вкладку Tenders. Там список банков для казначейских счетов и торговые площадки.',
  'гарантия': 'Банковскую гарантию можно оформить через вкладку Guarantees. Там 5 банков с условиями и ставками.',
  '1с': 'Интеграция с 1С уже работает. Перейдите на вкладку 1C — там ваши счета и контрагенты из 1С:Бухгалтерии.',
  'помощь': 'Я AI-Ко-фаундер Khepri. Могу ответить на вопросы о налогах, договорах, контрагентах, торгах, гарантиях, 1С и банках. Просто напишите ключевое слово.',
};

function AIChat() {
  const [messages, setMessages] = useState([
    { from: 'ai', text: '👋 Привет! Я AI-Ко-фаундер Khepri. Задайте вопрос о налогах, договорах, контрагентах, торгах, гарантиях, 1С или банках.' },
  ]);
  const [input, setInput] = useState('');
  const chatEnd = useRef(null);

  useEffect(() => {
    chatEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const send = () => {
    const text = input.trim();
    if (!text) return;

    setMessages(prev => [...prev, { from: 'user', text }]);
    setInput('');

    setTimeout(() => {
      const answer = findAnswer(text.toLowerCase());
      setMessages(prev => [...prev, { from: 'ai', text: answer }]);
    }, 500);
  };

  const findAnswer = (q) => {
    for (const [key, answer] of Object.entries(ANSWERS)) {
      if (q.includes(key)) return answer;
    }
    return 'Извините, я пока не знаю ответа на этот вопрос. Попробуйте спросить про: налоги, НДС, кассовый разрыв, контрагент, договор, счёт, торги, гарантия, 1С, помощь.';
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 180px)' }}>
      <h2>🤖 AI Co-Founder</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 12 }}>
        Ask me about taxes, contracts, counterparties, tenders, and more
      </p>

      <div style={{ flex: 1, overflowY: 'auto', marginBottom: 12, padding: '0 4px' }}>
        {messages.map((m, i) => (
          <div key={i} style={{ marginBottom: 10, display: 'flex', justifyContent: m.from === 'user' ? 'flex-end' : 'flex-start' }}>
            <div style={{
              maxWidth: '80%',
              padding: '10px 14px',
              borderRadius: 12,
              background: m.from === 'user' ? '#6366F1' : '#1E293B',
              color: '#F8FAFC',
              fontSize: 14,
              lineHeight: 1.5,
              border: m.from === 'ai' ? '1px solid #334155' : 'none',
            }}>
              {m.text}
            </div>
          </div>
        ))}
        <div ref={chatEnd} />
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && send()}
          placeholder="Ask me anything..."
          style={{
            flex: 1,
            padding: 10,
            background: '#0F172A',
            border: '1px solid #334155',
            borderRadius: 8,
            color: '#F8FAFC',
            fontSize: 14,
          }}
        />
        <button
          onClick={send}
          style={{
            padding: '10px 20px',
            background: '#6366F1',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
}

export default AIChat;